import AccountRequestAlert from './AccountRequestAlert';
import { connect } from 'react-redux';
import {
  accountViewActions,
  accountAddressRequestSel
} from 'src/store/modules/accountview';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: any) => {
  return {
    addressRequest: accountAddressRequestSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onClearAlert: () => {
    dispatch(accountViewActions.setShipRequestFailure(false));
    dispatch(accountViewActions.setShipRequestSuccess(false));
  }
});

export const pureComponent = AccountRequestAlert;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(AccountRequestAlert));

interface IDispatchFromProps {
  onClearAlert(): void;
}
